import { Button } from "../../../styles/MUI/Button"
import { BasePropertyInput } from "./BasePropertyInput"

export function ButtonPropertyInput(
    {
        children,
        color,
        variant,
        onClick,
        disabled,
        title
    }: {
        children: React.ReactNode,
        color?: "inherit" | "primary" | "secondary" | "success" | "error" | "info" | "warning" | undefined,
        variant?: "text" | "outlined" | "contained" | undefined,
        onClick: () => void,
        disabled?: boolean,
        title?: string
    }) {

    return (
        <BasePropertyInput disabled={disabled} title={title}>
            <Button
                fullWidth
                onClick={() => onClick()}
                color={color}
                variant={variant}
                disabled={disabled}
            >
                {children}
            </Button>
        </BasePropertyInput >
    )
}